import { types } from "../types/types"

export const saveDepartamentos = (data) => {
    return {
        type: types.departamentos,
        payload: data
    }
}